import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { NbRoleProvider } from '@nebular/security';
import { map } from 'rxjs/operators';
import { UserJWT } from './models/UserInfo.model';


@Injectable()
export class AppRoleProvider implements NbRoleProvider {

  constructor(private authService: NbAuthService) {
  }

getRole(): Observable<string[] | string> {
  return new Observable(observer => {
    const rolesRaw = localStorage.getItem('UserRoles');
    let roles: string[];

    try {
      roles = rolesRaw ? JSON.parse(rolesRaw) : ['Guest'];
    } catch {
      roles = ['Guest'];
    }

  
    observer.next(roles);
    observer.complete();
  });
}


}
